import * as React from 'react';
import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
export var FormContextContainer = function (props) {
    var initial = props.initial, children = props.children;
    return (React.createElement(RampWithNameTransform, { rampName: "DataProvider", initial: initial }, children));
};
